import { render } from "./Mails.vue?vue&type=template&id=6dcffee6"
import script from "./Mails.vue?vue&type=script&lang=js"
export * from "./Mails.vue?vue&type=script&lang=js"

import "./Mails.vue?vue&type=style&index=0&id=6dcffee6&lang=less"

import exportComponent from "../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__